var util = require("./util");
var common = require("./common");
function PDFColumns(options, children) {
    options = options || {};
    this.children = children || [];
    // TODO: validate the inputs
    this.columns = util.getOption(options, "columns", [1]);
    this.height = 0;
    this.cache = new util.CalcCache();
}
PDFColumns.prototype.invalidate = function () {
    this.cache.clear();
    this.children.forEach(function (child) {
        if (typeof child.invalidate === "function")
            child.invalidate();
    });
};
function hashCursor(cursor) {
    return cursor.width;
}
PDFColumns.prototype.calc = function (cursor) {
    if (this.cache.has(hashCursor(cursor)))
        return this.cache.get(hashCursor(cursor));
    var columns = common.calculateColumns(this.columns, cursor.width), childCursor = {
        x: cursor.x,
        y: cursor.y,
        height: cursor.height,
        doc: cursor.doc
    }, calcHeight = 0;
    for (var i = 0; i < this.children.length; i++) {
        childCursor.width = columns[i];
        var measure = this.children[i].calc(childCursor);
        calcHeight = Math.max(calcHeight, measure.height);
        childCursor.x += childCursor.width;
    }
    var ret = {
        width: cursor.width,
        height: calcHeight
    };
    this.cache.set(hashCursor(cursor), ret);
    return ret;
};
PDFColumns.prototype.draw = function (cursor) {
    var columns = common.calculateColumns(this.columns, cursor.width), childCursor = {
        x: cursor.x,
        y: cursor.y,
        height: cursor.height,
        doc: cursor.doc
    }, calcHeight = 0;
    for (var i = 0; i < this.children.length; i++) {
        childCursor.width = columns[i];
        var measure = this.children[i].draw(childCursor);
        calcHeight = Math.max(calcHeight, measure.height);
        childCursor.x += childCursor.width;
    }
    return {
        width: cursor.width,
        height: calcHeight
    };
};
module.exports = PDFColumns;
//# sourceMappingURL=module.js.map